module.exports = __webpack_public_path__ + "79eef96467a099cd3d36dc9830d9d9f6.jpg";